import React from 'react'
import { Global } from '@emotion/core'
import { globalStyles } from '@ticketswap/solar'

export default () => {
  return <Global styles={globalStyles} />
}
